<template>
    <div class="status-wf aba-itens">
        <loader v-if="isLoading" />
        <empty-table-message v-if="!statusList || statusList.length === 0" />
        <div
            v-else
            class="vertical-flow"
        >
            <div
                v-for="(status, index) in statusList"
                :key="status.idLogStatusWfPda"
                class="timeline-item"
            >
                <div class="timeline-icon">
                    <b-icon
                        :icon="getIcon(status.statuswf_title)"
                        size="is-small"
                        type="is-primary"
                    />
                </div>

                <div class="timeline-content">
                    <p 
                        class="status-title" 
                        :title="$t(status.table_name == 'logstatuswfpda' ? 'interno' : 'erp')"
                    >
                        {{ status.sigla }}
                    </p>
                    <p class="status-desc">
                        {{ getT(status.statuswf_title) }}
                    </p>
                    <p class="status-date">
                        {{ status.datahora | moment('L LT') }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StatusWF',
    props: {
        pedido: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            statusList: [],
            isLoading: false,
        };
    },
    created() {
        this.buscarStatus();
    },
    methods: {
        getIcon(identificador) {
            if (!identificador) return 'alert-circle-outline';

            const idLower = identificador.toLowerCase().replace(/_/g, ' ');
            if (idLower.includes('criado')) return 'cart-plus';
            if (idLower.includes('alterado')) return 'pencil';
            if (idLower.includes('transmitido')) return 'sync';
            if (idLower.includes('cancelado')) return 'close-circle';
            if (idLower.includes('enviado')) return 'send';
            if (idLower.includes('aprovado')) return 'thumb-up';
            if (idLower.includes('reprovado')) return 'thumb-down';

            return 'information-outline';
        },

        buscarStatus() {
            this.isLoading = true;

            const params = {
                pedido_from: this.$route.params.origem || '',
                idpedidosovis: this.pedido.idpedidosovis || '',
                uuidpedido: this.pedido.uuid || '',
            };
            this.$axios
                .get(`/pedido/${this.pedido.idpedido}/workflow-pedido.json`, { params })
                .then((response) => {
                    this.statusList = response.data;
                    this.$emit('current-workflow', this.statusList.length > 0 ? this.statusList[0] : null);
                })
                .catch(() => {
                    this.statusList = [];
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-itens {
    padding: 20px 0;
    height: 100%;
}


.vertical-flow {
    position: relative;

    .timeline-item {
        display: flex;
        margin-bottom: 20px;
        position: relative;

        .timeline-icon {
            position: relative;
            z-index: 1;
            background: #fff;
            border-radius: 50%;
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 2px solid var(--primary-color, #3273dc);
            flex-shrink: 0;
        }

        .timeline-content {
            margin-left: 16px;

            .status-title {
                font-weight: bold;
                margin: 0;
            }

            .status-desc {
                margin: 0;
                font-size: 0.8rem;
                color: #666;
            }

            .status-date {
                margin: 2px 0 0 0;
                font-size: 0.8rem;
                color: #999;
            }
        }

        // Linha vertical entre os itens
        &::before {
            content: '';
            position: absolute;
            left: 16px;
            top: 16px;
            bottom: -20px; // estende até o próximo item
            width: 2px;
            background-color: var(--primary-color, #3273dc);
            z-index: 0;
        }

        // Remove a linha do último item
        &:last-child::before {
            display: none;
        }

        
    }
}
</style>
